module.exports = __webpack_public_path__ + "static/MIT_950-c0c0fc7022332611bb1441ba99782e96.jpg";